import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  fyeList: [],
  uniqueFYEDate: [],
  uniqueBuildingAccManager: [],
  fyInternalReviewStatus: [],
  uniqueAccountingMethod: [],
};

const FinancialYearEndSlice = createSlice({
  name: "FinancialYearEndSlice",
  initialState,
  reducers: {
    setFYEList: (state, action) => {
      state.fyeList = action.payload;
    },
    setUniqueBuildingAccManager: (state, action) => {
      state.uniqueBuildingAccManager = action.payload;
    },
    setUniqueFYEDate: (state, action) => {
      state.uniqueFYEDate = action.payload;
    },
    setFYInternalReviewStatus: (state, action) => {
      state.fyInternalReviewStatus = action.payload;
    },
    setUniqueAccountingMethod: (state, action) => {
      state.uniqueAccountingMethod = action.payload;
    },
  },
});
export const {
  setFYEList,
  setUniqueFYEDate,
  setUniqueBuildingAccManager,
  setFYInternalReviewStatus,
  setUniqueAccountingMethod,
} = FinancialYearEndSlice.actions;

export default FinancialYearEndSlice.reducer;
